import axios, { AxiosResponse } from 'axios';
import { AxiosInstance } from '../../utilities/requestClient';

export type UploadFileVariables = {
  file: File;
  onProgress: (progress: number) => void;
};

export type UploadFileParams = UploadFileVariables & {
  url: string;
};

export const uploadFile = async <TResponse = unknown>({
  file,
  url,
  onProgress,
}: UploadFileParams): Promise<AxiosResponse<TResponse>> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await AxiosInstance.post<TResponse>(url, formData, {
    onUploadProgress: (progressEvent) => {
      const progress = Math.round(
        (progressEvent.loaded * 100) / (progressEvent.total || 1),
      );
      onProgress(progress);
    },
  });

  return response;
};

export function getUploadErrorMessage(
  error: unknown,
  fallback = 'Upload failed. Please try again.',
): string {
  if (axios.isAxiosError(error)) {
    if (error.response?.data?.detail) {
      return String(error.response.data.detail);
    }
    if (typeof error.response?.data === 'string') {
      return error.response.data;
    }
    if (error.message) {
      return error.message;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
}
